// This file was auto-generated by Fern from our API Definition.
export var EvaluationRunDataStepInput;
(function (EvaluationRunDataStepInput) {
    EvaluationRunDataStepInput.Type = {
        Input: "input",
        Invocation: "invocation",
        Annotation: "annotation",
    };
    EvaluationRunDataStepInput.Origin = {
        Custom: "custom",
        Human: "human",
        Auto: "auto",
    };
})(EvaluationRunDataStepInput || (EvaluationRunDataStepInput = {}));
